import {
  getAllUtilitiesSubcategoryKeywords,
  getLocaleAwareSubcategoryKeywords,
  getUtilitiesSubcategoryPriority,
} from './languages';
import {
  type SubcategoryConfig,
  type SubcategoryResult,
  detectSubcategory,
} from './subcategoryDetection';
import { EXPENSE_TAXONOMY } from './taxonomy';

export const UTILITIES_KEYWORDS = getAllUtilitiesSubcategoryKeywords();

/** Derived from the canonical `EXPENSE_TAXONOMY`. See taxonomy.ts. */
export const VALID_UTILITIES_SUBCATEGORIES =
  EXPENSE_TAXONOMY.utilities as readonly string[] as string[];

export const UTILITIES_CONFIG: SubcategoryConfig = {
  keywords: UTILITIES_KEYWORDS,
  validSubcategories: VALID_UTILITIES_SUBCATEGORIES,
  contextKeywords: {},
  minConfidenceThreshold: 0.3,
  subcategoryPriority: getUtilitiesSubcategoryPriority(),
};

export function detectUtilitiesSubcategory(description: string): string {
  return detectSubcategory(description, UTILITIES_CONFIG).subcategory;
}

export function detectUtilitiesSubcategoryWithConfidence(
  description: string
): SubcategoryResult {
  return detectSubcategory(description, UTILITIES_CONFIG);
}

/**
 * Locale-aware utilities subcategory detector. Combines global brand
 * keywords (Hydro-Québec, Comcast, Verizon, Rogers, EDF, Engie, EnBW,
 * Vivo, Telmex, Sabesp, IPTU, Netflix/Disney+/Sky/etc.) with the user's
 * primary-language common-word vocabulary. Returns `default@0` when
 * locale doesn't resolve so cloud LLM can step in.
 */
export function detectUtilitiesSubcategoryWithLocale(
  description: string,
  locale: string | undefined | null
): SubcategoryResult {
  const keywords = getLocaleAwareSubcategoryKeywords(
    b => b.utilitiesSubcategories,
    k => k.utilitiesSubcategories,
    locale
  );
  if (!keywords) {
    return { subcategory: 'default', confidence: 0, matchedKeywords: [] };
  }
  return detectSubcategory(description, {
    ...UTILITIES_CONFIG,
    keywords,
  });
}
